var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"main-page"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","lg":"2"}},[_c('HomeMenu')],1),_c('v-col',{attrs:{"cols":"12","lg":"10"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }